import React from 'react';
import { ArrowRight, Loader2 } from 'lucide-react';

const Button = ({ 
  children, 
  href, 
  variant = 'primary', 
  size = 'medium',
  withArrow = false,
  loading = false,
  disabled = false,
  className = '',
  fullWidth = false,
  type = 'button',
  onClick
}) => {
  const baseStyles = "font-bold rounded-lg transition duration-150 ease-in-out flex items-center justify-center";
  
  const variantStyles = {
    primary: "bg-blue-600 hover:bg-blue-700 text-white",
    secondary: "bg-white text-blue-600 hover:bg-blue-100",
    outline: "border-2 border-blue-600 text-blue-600 hover:bg-blue-50"
  };
  
  const sizeStyles = {
    small: "py-2 px-4 text-sm",
    medium: "py-3 px-6",
    large: "py-4 px-8 text-lg"
  };
  
  const widthClass = fullWidth ? "w-full" : "";
  
  const styles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthClass} ${className}`;
  
  const content = (
    <>
      {loading ? (
        <>
          <Loader2 className="animate-spin mr-2 h-5 w-5" />
          Loading...
        </>
      ) : (
        <>
          {children}
          {withArrow && <ArrowRight className="ml-2 h-5 w-5" />}
        </>
      )}
    </>
  );
  
  if (href && !disabled) {
    return (
      <a href={href} className={styles}>
        {content}
      </a>
    );
  }
  
  return (
    <button
      type={type}
      className={styles}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {content}
    </button>
  );
};

export default Button;